import React from "react";
import { Accordion } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { BusinessNameSection } from "./BusinessNameSection";
import { CategorySection } from "./CategorySection";
import { EditProfileFormSectionKeys } from "./const";
import { OpenInfoSection } from "./OpenInfoSection";
import { PhoneNumbersSection } from "./PhoneNumbersSection";
import { ProfileSection } from "./ProfileSection";
import { RegularHoursSection } from "./RegularHoursSection";
import { SocialLinksSection } from "./SocialLinksSection";
import { SpecialHoursSection } from "./SpecialHoursSection";
import { WebsiteSection } from "./WebsiteSection";
import { LocationData } from "../../../models/LocationData";
import { AccordionButton } from "../../Common/Accordion/AccordionButton";

import "./styles.scss";

export interface IEditProfileFormProps {
  locationData: LocationData;
  defaultAccordionEventKey?: EditProfileFormSectionKeys | null | undefined;
}

export const EditProfileForm: React.FunctionComponent<IEditProfileFormProps> = (
  props
) => {
  const { locationData, defaultAccordionEventKey } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.modalEditProfile.editProfileForm.${key}`);

  return (
    <div className="edit-profile-form">
      <Accordion defaultActiveKey={defaultAccordionEventKey}>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.BUSINESS_NAME}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.BUSINESS_NAME}
          >
            {t("business_name")}
          </AccordionButton>
          <Accordion.Body>
            <BusinessNameSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.BUSINESS_NAME}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.CATEGORY}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.CATEGORY}
          >
            {t("categories")}
          </AccordionButton>
          <Accordion.Body>
            <CategorySection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.CATEGORY}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.DESCRIPTION}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.DESCRIPTION}
          >
            {t("description")}
          </AccordionButton>
          <Accordion.Body>
            <ProfileSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.DESCRIPTION}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.PHONE_NUMBERS}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.PHONE_NUMBERS}
          >
            {t("phone_numbers")}
          </AccordionButton>
          <Accordion.Body>
            <PhoneNumbersSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.PHONE_NUMBERS}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.WEBSITE}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.WEBSITE}
          >
            {t("website")}
          </AccordionButton>
          <Accordion.Body>
            <WebsiteSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.WEBSITE}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.OPEN_INFO}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.OPEN_INFO}
          >
            {t("open_info")}
          </AccordionButton>
          <Accordion.Body>
            <OpenInfoSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.OPEN_INFO}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.REGULAR_HOURS}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.REGULAR_HOURS}
          >
            {t("regular_hours")}
          </AccordionButton>
          <Accordion.Body>
            <RegularHoursSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.REGULAR_HOURS}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.SPECIAL_HOURS}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.SPECIAL_HOURS}
          >
            {t("special_hours")}
          </AccordionButton>
          <Accordion.Body>
            <SpecialHoursSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.SPECIAL_HOURS}
            />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey={EditProfileFormSectionKeys.SOCIAL_LINKS}>
          <AccordionButton
            accordionItemKey={EditProfileFormSectionKeys.SOCIAL_LINKS}
          >
            {t("social_links")}
          </AccordionButton>
          <Accordion.Body>
            <SocialLinksSection
              locationData={locationData}
              accordionEventKey={EditProfileFormSectionKeys.SOCIAL_LINKS}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
